import React, { useState } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { Content, Text, TextInput, Label, Button, Pane, Flex } from '@leverege/ui-elements'

import { JsonEditorDialog, InsetSection } from '~/views'

import S from './EnumEditorStyle.css'

function EnumValueEditor( { actions, enumType, item, dispatch } ) {
  if ( !item ) return null

  const [ showJsonEditor, setShowJsonEditor ] = useState( false )
  const { value, name, description, metadata } = item

  const stringifiedMetadata = metadata ? JSON.stringify( metadata, null, 2 ) : null
  const onChange = ( { value : nVal, data } ) => {
    let toUpdate = data === 'name' && !nVal ? value : nVal
    toUpdate = typeof toUpdate === 'string' ? toUpdate.trim() : toUpdate
    dispatch( actions( enumType ).updateValue( value, { [data] : toUpdate } ) )
    setShowJsonEditor( false )
  }
  return (
    <Pane className={classnames( S.editorPanel )}>
      <Content>
        <Content.Header>
          <Pane className={S.title} variant="screenTitle">
            <Text variant="caption">{`${enumType} Value`}</Text>
            <Text variant="cardTitle">{value}</Text>
          </Pane>
        </Content.Header>
        <Content.Area>
          <Pane className={S.formBody} variant="formBody">
            <div className={S.inputGroup}>
              <Label variant="input">Name</Label>
              <TextInput
                onChange={onChange}
                eventData="name"
                value={name} />
            </div>
            <div className={S.inputGroup}>
              <Label variant="input">Description</Label>
              <TextInput onChange={onChange} eventData="description" value={description} />
            </div>
            <div className={S.inputGroup}>
              <Flex direction="row" className={S.metadata}>
                <Label style={{ marginRight : 8 }}>Metadata</Label>
                <Button variant="secondarySmall" onClick={() => setShowJsonEditor( true )}>
                  {stringifiedMetadata ? 'Edit' : 'Add'}
                </Button>
              </Flex>
              <InsetSection>
                {stringifiedMetadata ? <pre>{stringifiedMetadata}</pre> : 'No Metadata'}
              </InsetSection>
              <JsonEditorDialog
                title="Enum Metadata"
                message="Enter the JSON object for the value metadata"
                show={showJsonEditor}
                onOk={value => onChange( { data : 'metadata', value } )}
                onCancel={() => setShowJsonEditor( false )}
                value={metadata} />
            </div>
          </Pane>
        </Content.Area>
      </Content>
    </Pane>
  )
}

export default connect()( EnumValueEditor )
